import type { ViewjobQueryResult } from "../__generated__/viewjob.gqlgenerated";

import { useApplyLinkQuery } from "../__generated__/applyLink.gqlgenerated";

type UseApplyLinkProps = {
  jobKey: string | null | undefined;
  viewJobData: ViewjobQueryResult["data"];
  viewJobQueryCompleted: boolean;
  url: string | null;
};

export function getApplyLinkSource(url: string | null, isApplyPlusRsvpEnabled: boolean): string {
  const indeedApplySource = url ? new URL(url).searchParams.get("indapplysrc") : null;

  // TODO: Support isDesktop for React Native Web
  const isDesktop = false;

  let source: string;
  if (indeedApplySource) {
    source = indeedApplySource;
  } else if (!isDesktop) {
    source = "idm";
  } else {
    source = "idd-vj";
  }

  if (isApplyPlusRsvpEnabled) {
    return source + "-ihp-apply-rsvp";
  }
  return source;
}

/**
 * Hook to fetch the Indeed Apply link URL asynchronously.
 * This query depends on data from the viewjob query (mobvjtk, continueUrl, clientMeta).
 * It runs after the viewjob query completes and does not block the main content rendering.
 */
export const useApplyLink = ({
  jobKey,
  viewJobData,
  viewJobQueryCompleted,
  url,
}: UseApplyLinkProps) => {
  const applyMethod = viewJobData?.viewjob?.details?.applyMethod;
  const indeedApplyMethod = applyMethod?.__typename === "ViewJobIndeedApply" ? applyMethod : null;

  const source = getApplyLinkSource(url, indeedApplyMethod?.isApplyPlusRsvpEnabled === true);

  const spn = viewJobData?.viewjob?.details?.isSponsored ?? false;

  const { data, loading, error, refetch } = useApplyLinkQuery({
    variables: {
      input: jobKey ?? "",
      mobvjtk: viewJobData?.viewjob?.details?.mobvjtk ?? "",
      continueUrl: indeedApplyMethod?.continueUrl ?? "",
      spn,
      clientMeta: indeedApplyMethod?.clientMeta ?? "",
      source,
    },
    fetchPolicy: "no-cache",
    skip: !viewJobQueryCompleted || !jobKey || !indeedApplyMethod,
  });

  const applyLinkUrl = data?.jobData?.results?.[0]?.job?.indeedApply?.applyLink?.url ?? null;

  return {
    applyLinkUrl,
    applyLinkLoading: loading,
    applyLinkError: error,
    refetchApplyLink: refetch,
  };
};
